/** Owns the hidden media elements created for subscribed remote audio tracks. */
export interface AttachableRemoteAudioTrack {
  attach(): HTMLMediaElement;
  detach(): HTMLMediaElement[];
}

export function attachRemoteAudio(track: AttachableRemoteAudioTrack): HTMLMediaElement {
  const element = track.attach();
  element.autoplay = true;
  element.dataset.momentumRemoteAudio = 'true';
  document.body.append(element);
  return element;
}

export function detachRemoteAudio(track: AttachableRemoteAudioTrack): void {
  for (const element of track.detach()) element.remove();
}
